import CreateAxiosInstance from './axiosConfig';

// useAuth: false. /feature-flags/mixpanel-tagged is a no_auth route that returns
// the same tag-derived flag list for everyone, and the auth path in the request
// interceptor does `await clerk.load()` — which would put this request BEHIND
// Clerk (measured: clerk +1196ms, request +1473ms) and defeat the whole point of
// starting it at bootstrap alongside LaunchDarkly init.
const APIClient = CreateAxiosInstance(import.meta.env.VITE_API_BASE_URL, false);

// Cache a SUCCESSFUL non-empty fetch for the session. Don't cache an error
// or an empty-list response — a transient LD hiccup at deploy time or a
// backend-side boot-fetch failure would otherwise leave the client with no
// flag attribution until the tab reloads.
let cachedFlags = null;

export async function getMixpanelTaggedFlags() {
  if (cachedFlags && cachedFlags.length > 0) return cachedFlags;
  try {
    const { data } = await APIClient.get('/feature-flags/mixpanel-tagged');
    const flags = data?.flags || [];
    if (flags.length > 0) cachedFlags = flags;
    return flags;
  } catch (err) {
    console.error('Failed to fetch mixpanel-tagged flags', err);
    return [];
  }
}

// Started at app bootstrap so this request is in flight *alongside* LaunchDarkly
// initialization instead of being a second, serial round trip that only begins
// once React has mounted. The flag list gates when flag_* super-props can be
// stamped on events, so its latency is on the critical path for attribution.
let inFlight = null;

export function primeMixpanelTaggedFlags() {
  if (!inFlight) {
    inFlight = getMixpanelTaggedFlags().then((flags) => {
      // Never hold on to an empty result: the caller retries with backoff, and a
      // retry must issue a fresh request rather than re-await this same
      // already-resolved empty promise.
      if (!flags || flags.length === 0) inFlight = null;
      return flags;
    });
  }
  return inFlight;
}
